<template>
  <el-input
    class="base-input"
    :class="{ 'is-block': block }"
    :model-value="modelValue"
    :type="type"
    :size="normalizedSize"
    :placeholder="placeholder"
    :disabled="disabled"
    :clearable="clearable"
    :show-password="showPassword"
    :maxlength="maxlength"
    :show-word-limit="showWordLimit"
    @update:model-value="$emit('update:modelValue', $event)"
    @blur="$emit('blur', $event)"
    @focus="$emit('focus', $event)"
    @change="$emit('change', $event)"
  >
    <template v-if="$slots.prefix" #prefix>
      <slot name="prefix" />
    </template>
    <template v-if="$slots.suffix" #suffix>
      <slot name="suffix" />
    </template>
    <template v-if="$slots.prepend" #prepend>
      <slot name="prepend" />
    </template>
    <template v-if="$slots.append" #append>
      <slot name="append" />
    </template>
  </el-input>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
  type: {
    type: String,
    default: 'text'
  },
  size: {
    type: String,
    default: 'default'
  },
  placeholder: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  clearable: {
    type: Boolean,
    default: false
  },
  showPassword: {
    type: Boolean,
    default: false
  },
  maxlength: {
    type: Number,
    default: undefined
  },
  showWordLimit: {
    type: Boolean,
    default: false
  },
  block: {
    type: Boolean,
    default: true
  }
})

defineEmits(['update:modelValue', 'blur', 'focus', 'change'])

const normalizedSize = computed(() => {
  if (props.size === 'large' || props.size === 'small' || props.size === 'default') {
    return props.size
  }
  return 'default'
})
</script>

<style scoped lang="scss">
.base-input {
  :deep(.el-input__wrapper) {
    border-radius: var(--radius-md);
    box-shadow: 0 0 0 1px var(--color-border) inset;
    transition:
      box-shadow var(--motion-fast) var(--ease-standard),
      border-color var(--motion-fast) var(--ease-standard);
  }

  :deep(.el-input__wrapper:hover) {
    box-shadow: 0 0 0 1px #b8b8be inset;
  }

  :deep(.el-input__wrapper.is-focus) {
    box-shadow:
      0 0 0 1px var(--color-primary) inset,
      var(--focus-ring);
  }
}

.is-block {
  width: 100%;
}
</style>
